module.exports = __webpack_public_path__ + "assets/img/btn-back-ad79852c.png";